export const ERROR_CODES_FIREBASE = {
  EMAIL_IN_USE: 'auth/email-already-in-use',
  EMAIL_NOT_FOUND: 'auth/user-not-found',
  WRONG_PASSWORD: 'auth/wrong-password',
  ACCOUNT_EXISTS: 'auth/account-exists-with-different-credential',
} as const;

export const GOOGLE_CLIENT_ID =
  '483008214107-io49o51ekp7qff7tcpj1o3idpkdcioq6.apps.googleusercontent.com';
